<template>
  <b-form-select
    v-model="selected"
    :show-labels="false"
    :id="id"
    :class="filterClass"
    :disabled="disable"
    :value-field="trackBy"
    :text-field="titleBy"
    :options="options"
    :multiple="multiple"
    :required="isRequired"
  >
    <!-- This slot appears above the options from 'options' prop -->
    <template slot="first">
      <b-form-select-option :value="null" disabled>
        -- Please select an option --
      </b-form-select-option>
    </template>
  </b-form-select>
</template>

<script>
export default {
  name: "ChildSelect",
  props: {
    id: { type: String, default: `${Math.random()}` },
    label: { type: String, default: "Label" },
    disable: { type: Boolean, default: false },
    multiple: { type: Boolean, default: false },
    options: { type: Array, default: null },
    filterClass: { type: Array, required: false },
    isRequired: { type: Boolean, default: false },
    titleBy: { type: String, default: "title" },
    trackBy: { type: String, default: "value.id" },
    selectedValue: { type: Object, default: null },
  },
  data() {
    return {};
  },
  computed: {
    matchingItem() {
      try {
        return this.options.find(
          (i) =>
            Number.parseInt(i.value.id, 10) ===
            Number.parseInt(this.selected, 10),
        );
      } catch {
        return null;
      }
    },
    selected: {
      get: function () {
        const ret =
          this.selectedValue !== null ? this.selectedValue.value : null;
        return ret ? ret.toString() : null;
      },
      set: function (value) {
        value = this.options.find((item) => item.value.id == value);
        this.$emit("select", value);
      },
    },
  },
};
</script>
